import * as Constants from '../constants';

export function startingSource({ sourceId }) {
  return {
    type: Constants.Integrations.ActionTypes.STARTING_SOURCE,
    data: {
      sourceId,
    },
  };
}

export function sourceStarted({ sourceId }) {
  return {
    type: Constants.Integrations.ActionTypes.SOURCE_STARTED,
    data: {
      sourceId,
    },
  };
}

export function startSourceIncomplete({ sourceId }) {
  return {
    type: Constants.Integrations.ActionTypes.START_SOURCE_INCOMPLETE,
    data: {
      sourceId,
    },
  };
}

export function newTrackStartedFromSource(data) {
  return {
    type: Constants.Integrations.ActionTypes.TRACK_STARTED_FROM_SOURCE,
    data,
  };
}

export function trackInterrupted({ previousSourceId, previousType, previousTrack }) {
  return {
    type: Constants.Integrations.ActionTypes.TRACK_INTERRUPTED,
    data: {
      previousSourceId,
      previousType,
      previousTrack,
    },
  };
}

export function feedbackAdded({ sourceId, trackToken, isPositive }) {
  return {
    type: Constants.Integrations.ActionTypes.FEEDBACK_ADDED,
    data: {
      sourceId,
      trackToken,
      isPositive,
    },
  };
}

export function feedbackRemoved({ sourceId, trackToken, isPositive }) {
  return {
    type: Constants.Integrations.ActionTypes.FEEDBACK_REMOVED,
    data: {
      sourceId,
      trackToken,
      isPositive,
    },
  };
}

export function componentClicked(data) {
  return {
    type: Constants.Integrations.ActionTypes.COMPONENT_CLICKED,
    data,
  };
}

export function componentViewed(data) {
  return {
    type: Constants.Integrations.ActionTypes.COMPONENT_VIEWED,
    data,
  };
}

export function signUpClicked() {
  return {
    type: Constants.Integrations.ActionTypes.SIGN_UP_CLICKED,
  };
}

export function logInClicked() {
  return {
    type: Constants.Integrations.ActionTypes.LOG_IN_CLICKED,
  };
}

export function viewPlansClicked() {
  return {
    type: Constants.Integrations.ActionTypes.VIEW_PLANS_CLICKED,
  };
}

export function appStoreClicked() {
  return {
    type: Constants.Integrations.ActionTypes.APP_STORE_CLICKED,
  };
}

export function imageFetchErrored(data) {
  return {
    type: Constants.Integrations.ActionTypes.IMAGE_FETCH_ERRORED,
    data,
  };
}

export function graphQLFetched(data) {
  return {
    type: Constants.Integrations.ActionTypes.GRAPHQL_FETCHED,
    data,
  };
}
